import { AVAILABILITY_OVERRIDES } from './constants'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import { useTranslation } from 'react-i18next'
import { useStoreSelector } from 'hooks/store.ts'
import { useGetLanguage } from 'hooks/use-get-language'
import { DAY_OF_WEEK } from 'constants/datetime.ts'
import { isWeekend, toBelgianTime } from 'utils/date.ts'
import { selectIsProducerAccount } from 'store/contact/slice.ts'

dayjs.extend(isBetween)

export const PhoneAvailability = () => {
  // Redux
  const isProducer = useStoreSelector(selectIsProducerAccount)

  // i18n
  const { t } = useTranslation('support')
  const language = useGetLanguage()

  // Constants
  const today = toBelgianTime() // (the opening hours below are the Belgian ones, so they may not be read on the clock of the device)
  const isBetweenRegularHours = today.hour() >= 9 && today.hour() < 18
  const available = !isWeekend(today) && isBetweenRegularHours
  const availableButBeforeOpeningHours = !isWeekend(today) && today.hour() < 9
  const availableTomorrow = today.day() !== DAY_OF_WEEK.friday && today.day() !== DAY_OF_WEEK.saturday
  const phoneAvailabilityOverride = AVAILABILITY_OVERRIDES.find(
    (override) =>
      override.userType === (isProducer ? 'producer' : 'consumer') &&
      today.isBetween(override.start, override.end) &&
      (override?.dayOfWeek?.length ? override?.dayOfWeek.includes(today.day()) : true)
  )

  if (phoneAvailabilityOverride && language in phoneAvailabilityOverride.message) return phoneAvailabilityOverride.message[language]

  if (available) return t(($) => $.availability.available)

  if (availableButBeforeOpeningHours) return t(($) => $.availability.availableButBeforeOpeningHours)

  if (availableTomorrow) return t(($) => $.availability.availableTomorrow)

  return t(($) => $.availability.availableNextMonday)
}
